import { CSSProperties } from 'react';
import { clsx } from 'modules/Utils';
import BudgetSelector from './BudgetSelector';
import DatesCampaign from './DatesCampaign';
import { borderBottomLeftRadius } from 'html2canvas/dist/types/css/property-descriptors/border-radius';

interface BudgetDateSelectorProps {
    className?: string;
    style?: CSSProperties;
}

const BudgetDateSelector = ({
    className,
    style
}: BudgetDateSelectorProps) => {
    return (
        <div
            className={clsx('budgetDateSelector', className)}
            style={style}
        >
            <BudgetSelector
                className="budgetSelector"
                style={{
                    borderBottomLeftRadius: 0,
                    borderBottomRightRadius: 0,
                }}
            />
            <DatesCampaign
                className="datesCampaign"
                style={{
                    paddingTop: 16,
                    borderTopLeftRadius: 0,
                    borderTopRightRadius: 0,
                }}
                description="Select the length of your campaign."
            />
        </div>
    );
};

export default BudgetDateSelector;
